import axios from 'axios';
import moment from 'moment';

export async function getWorkTaskPlanning(startDate, endDate, token) {
    let url = '/api/Planning/GetWorkTaskPlanning';
    const queryParams: string[] = [];

    if (startDate) {
        // Get Monday of the week for startDate using moment
        const mondayOfWeek = moment(startDate).startOf('isoWeek').toDate();
        queryParams.push(`startDate=${encodeURIComponent(mondayOfWeek.toISOString())}`);
    }

    if (endDate) {
        // Get Sunday (end of the week) for endDate using moment
        const sundayOfWeek = moment(endDate).endOf('isoWeek').toDate();
        queryParams.push(`endDate=${encodeURIComponent(sundayOfWeek.toISOString())}`);
    }

    if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`;
    }
    const res = await axios.get(url, getHeaders(token));
    try {

        for (let i = 0; i < res.data.length; i++) {
                res.data[i].StartDate = new Date(res.data[i].StartDate);
                res.data[i].EndDate = new Date(res.data[i].EndDate);
        }
        return res.data;
    }
    catch {
        return res;
    }
}

export async function getWorkTaskByKey(workTaskOid, token) {
    const res = await axios.get(`/api/odata/WorkTask(${workTaskOid})?$expand=Activity,Employees,Relation`, getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export async function postCreateInvoice(workTaskOid, token) {
    const res = await axios.post('/api/WorkTask/InsertExcatOnlineInvoice', { workTaskOid : workTaskOid }, getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export async function getUnscheduledWorkTasks(token) {
    const res = await axios.get('/api/Planning/GetUnscheduledTasks', getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

const getHeaders = (token) => {
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
};
